import React from "react";

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarInset,
  SidebarProvider,
} from "@/styles/ui/sidebar";
import { SidebarWorkspaceBody } from "./body";
import { Overlay, SidebarWorkspaceTrigger } from "./common";
import { NavUser } from "./footer";
import { SidebarWorkspaceHeader } from "./header";

const CollapsedSidebar = () => {
  return (
    <div className="hidden h-full flex-col justify-between bg-background group-data-[state=collapsed]:flex">
      <div className="size-12 flex justify-center items-center">
        <SidebarWorkspaceTrigger />
      </div>
    </div>
  );
};

function CategoryView() {
  return (
    <div className="flex w-64 h-full flex-col bg-background">
      <SidebarWorkspaceHeader />
      <SidebarWorkspaceBody />
    </div>
  );
}

export function AppSidebar() {
  return (
    <Sidebar
      collapsible="icon"
      className="group bg-white z-50"
      variant="sidebar"
      style={
        {
          "--sidebar-width": "256px",
          "--sidebar-width-icon": "48px",
        } as React.CSSProperties
      }
    >
      <SidebarContent className="flex gap-0 p-0">
        <div className="flex-1 overflow-hidden group-data-[state=collapsed]:hidden">
          <CategoryView />
        </div>
        <CollapsedSidebar />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  );
}

export default function SidebarLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <SidebarProvider defaultOpen>
      <AppSidebar />
      <Overlay />
      <SidebarInset className="absolute pl-12">{children}</SidebarInset>
    </SidebarProvider>
  );
}
